import React from 'react'
import './dashCard.scss'

export interface IDashCard {
  icon: React.ReactNode
  iconVariant?: string
  label: string
  value: string | number
  change?: string
  changeType?: 'up' | 'down'
}

const DashCard: React.FC<IDashCard> = ({
  icon,
  iconVariant,
  label,
  value,
  change,
  changeType
}) => {
  return (
    <div className="stat-card">
      <div className="stat-card__icon-wrapper">
        <span
          className={`stat-card__icon${iconVariant ? ` stat-card__icon--${iconVariant}` : ''}`}
        >
          {icon}
        </span>
      </div>
      <div className="stat-card__content">
        <h3 className="stat-card__value">{value}</h3>
        <p className="stat-card__label">{label}</p>
        {change && (
          <span
            className={`stat-card__change stat-card__change--${changeType}`}
          >
            {change} from last month
          </span>
        )}
      </div>
    </div>
  )
}

export default DashCard
